import axios from 'axios';
const availableHosts = {
    'm.la.loc:3000': location.protocol + '//api.la.loc:8082/api/v2/',
    'm-fonds-dev.linkavie.com': location.protocol + '//api-dev.linkavie.com/api/v2/',
    'm-fonds-dev.airitage.fr': location.protocol + '//api-dev.airitage.fr/api/v2/',
    'm-fonds.linkavie.com': location.protocol + '//api.linkavie.com/api/v2/',
    'm-fonds.airitage.fr': location.protocol + '//api.airitage.fr/api/v2/',
    'm-fonds2.linkavie.com': location.protocol + '//api2.linkavie.com/api/v2/',
    'm-fonds2.airitage.fr': location.protocol + '//api2.airitage.fr/api/v2/',
};
export const getBaseUrl = () => availableHosts[location.host] ? availableHosts[location.host] : availableHosts['m-social.airitage.fr'];
export const api = {
    get: (url, params) => axios.get(url, {
        baseURL: getBaseUrl(),
        ...params,
        withCredentials: true,
    }),
    post: (url, data) => axios.post(url, data, {
        baseURL: getBaseUrl(),
    }),
    patch: (url, data) => axios.patch(url, data, {
        baseURL: getBaseUrl(),
    }),
    delete: (url) => axios.delete(url, {
        baseURL: getBaseUrl(),
    }),
};
